/**
 * 手机上的网络提示：什么时候该说一句、说什么。纯函数，方便单测。
 *
 * 桌面端顶栏常驻一个信号格，看一眼就知道；手机上顶栏会收起、
 * 而且 4G ⇄ WiFi 切换是常事 —— 网络变差要主动说，恢复了也要说，
 * 不然学员只看到画面卡了，不知道是自己的网还是老师的网。
 *
 * 只在**跨过「差」这条线**时说话：good ⇄ fair 之间的抖动不提示，
 * 否则一节课能弹十几次，用户会把它当噪音。
 */

export type NetLevel = 'unknown' | 'good' | 'fair' | 'poor'

export function netToastFor(prev: NetLevel, next: NetLevel): string | null {
  if (prev === next) return null
  if (next === 'poor') return '网络较差，画面可能卡顿'
  if (prev === 'poor' && (next === 'good' || next === 'fair')) return '网络已恢复'
  return null
}

/** 连接类型变了（WiFi ⇄ 蜂窝）要说一句：流量提醒比卡顿提醒更实际。 */
export function connToastFor(prev: string | undefined, next: string | undefined): string | null {
  if (!prev || !next || prev === next) return null
  if (next === 'wifi') return '已切换到 WiFi'
  if (next === 'cellular') return '已切换到手机流量，上课会消耗流量'
  return null
}
